// Device sizes
export const minWidthTabletHorizontal = "768px";
export const minWidthDesktopAlternative = "900px";
export const minWidthLaptop = "1024px";
export const minWidthDesktop = "1280px";
export const maxWidthDesktop = "1443px";
export const minWidthLargeDesktop = "1444px";

// Custom Colors
export const wbBlack = "#222222";
export const wbGreen = "#329911";
export const wbGreyLightest = "#F0F0F0";
export const wbOrange = "#FF9125";
export const wbRed = "#b20e0e";
export const wbBlue = "#1578bc";
export const white = "#FFFFFF";
export const greyBasic = "#F6F6F6";
export const greyLight = "#908f96";
export const greyLighter = "#E1E1E1";
export const backgroundButtonGrey = "#f6f6f6";
